import type { Template } from "@/types";

export const LA_04_H3_V1: Template[] = [
    {
        id: "la-04-h3v1-01",
        name: "LA 01 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 180, y: 41, width: 317, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 889, y: 41, width: 251, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 889, y: 194, width: 251, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 889, y: 347, width: 251, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-02",
        name: "LA 02 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 177, y: 38, width: 322, height: 454, rotation: 0, imageRotation: 0 },
            { id: "2", x: 781, y: 224, width: 466, height: 267, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 39, width: 230, height: 177, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 39, width: 229, height: 177, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-03",
        name: "LA 03 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 38, y: 39, width: 323, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1096, y: 39, width: 218, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1096, y: 193, width: 218, height: 144, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1096, y: 346, width: 218, height: 144, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-04",
        name: "LA 04 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 129, y: 40, width: 419, height: 291, rotation: 0, imageRotation: 0 },
            { id: "2", x: 129, y: 339, width: 206, height: 150, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 339, width: 206, height: 150, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 41, width: 317, height: 449, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-5",
        name: "LA 05 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 83, y: 73, width: 510, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 750, y: 73, width: 272, height: 190, rotation: 0, imageRotation: 0 },
            { id: "3", x: 750, y: 271, width: 272, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1030, y: 73, width: 251, height: 388, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-06",
        name: "LA 06 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 209, width: 383, height: 278, rotation: 0, imageRotation: 0 },
            { id: "2", x: 390, y: 209, width: 383, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 781, y: 209, width: 184, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 972, y: 209, width: 386, height: 278, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-07",
        name: "LA 07 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 67, y: 131, width: 343, height: 271, rotation: 0, imageRotation: 0 },
            { id: "2", x: 418, y: 131, width: 343, height: 271, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 131, width: 343, height: 271, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 131, width: 167, height: 271, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-08",
        name: "LA 08 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 38, y: 35, width: 312, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 270, width: 312, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 35, width: 649, height: 460, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1015, y: 35, width: 299, height: 460, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-09",
        name: "LA 09 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 39, y: 35, width: 312, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 39, y: 270, width: 312, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 358, y: 35, width: 300, height: 460, rotation: 0, imageRotation: 0 },
            { id: "4", x: 665, y: 35, width: 649, height: 460, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h3v1-10",
        name: "LA 10 - H3V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-04-h3_v1_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 34, width: 339, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 269, width: 339, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 34, width: 705, height: 461, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1060, y: 34, width: 292, height: 461, rotation: 0, imageRotation: 0 }
        ],
    }
];